/** 新建提交表单、检查报告和提交详情页（计划 E）。 */
export default {
  form: {
    title: '新建提交',
    back: '返回提交列表',
    notAllowed: '您无法创建提交。请管理员将您加入审核人或批准人组。',
    sectionSubmission: '提交',
    sectionDrawing: '图纸',
    sectionAttributes: '规划详情',
    sectionApplicant: '申请人',
    titleLabel: '项目名称',
    profileLabel: '规划类型',
    crsLabel: '坐标系',
    choose: '请选择…',
    fileLabel: 'CAD 图纸（.dwg 或 .dxf）',
    fileHint: '最大 {{max}} MB。支持 AutoCAD 2000 至 2018 版 DWG 或 DXF。',
    fileChosen: '{{name}}（{{size}}）',
    applicantName: '申请人姓名',
    applicantFirm: '公司',
    applicantEmail: '电子邮件',
    applicantRegNo: '专业注册号',
    submit: '提交检查',
    retry: '重试',
    cancelUpload: '取消上传',
    draftCreated: '草稿 {{caseRef}} 已创建。详情已锁定；重试将从上传步骤继续。',
    openSubmission: '打开提交',
    pollTimeout: '检查耗时超出预期。请打开提交以跟进。',
    errors: {
      required: '必填。',
      notANumber: '请输入数字。',
      notAYear: '请输入四位数年份。',
      email: '请输入有效的电子邮件地址。',
      fileMissing: '请选择要上传的图纸。',
      fileType: '请选择 .dwg 或 .dxf 文件。',
      fileEmpty: '文件为空。',
      fileTooLarge: '文件超过 {{max}} MB。',
    },
    phase: {
      creating: '正在创建提交…',
      uploading: '正在上传图纸… {{percent}}%',
      finalizing: '正在核对上传…',
      submitting: '正在提交…',
      checking: '正在转换并检查图纸…',
    },
  },
  report: {
    title: '检查报告',
    pending: '图纸仍在检查中（{{status}}）。',
    errored: '检查无法运行。审核人可以重试。',
    none: '此版本尚未运行检查。',
    zoomTo: '缩放至',
    areas: '面积',
    siteArea: '场地面积',
    declaredArea: '申报面积',
    byClass: '按土地用途',
    classColumn: '土地用途',
    areaColumn: '面积',
    plotsColumn: '地块数',
    unclassified: '未分类',
    noFindings: '没有发现问题。',
    revision: '版本 {{revision}}',
  },
  detail: {
    back: '返回提交列表',
    revision: '版本 {{revision}}',
    applicant: '申请人',
    attributes: '详情',
    profile: '规划类型',
    crs: '坐标系',
    map: '地图预览',
    revisions: '版本',
    timeline: '时间线',
    actions: '操作',
    noActions: '当前阶段没有可供您执行的操作。',
    viewReport: '查看报告',
    reportMissing: '无法加载检查报告。',
    replayed: '该操作此前已执行。',
    done: '完成。',
    notFound: '此提交不存在，或您无权查看。',
    disabledBecause: '不可用：{{reasons}}',
    columns: {
      revision: '版本',
      file: '文件',
      status: '检查',
      finished: '完成时间',
    },
  },
} as const
